import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid overflow-x-scroll overflow-y-scroll p-0 m-0" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "pb-6"
}
const _hoisted_4 = { class: "font-bold text-lg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "pb-6"
}
const _hoisted_8 = { class: "font-bold text-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_loading = _resolveComponent("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "onUpdate:active": _cache[0] || (_cache[0] = $event => ((_ctx.loading) = $event)),
      "can-cancel": false,
      "is-full-page": true,
      loader: "bars"
    }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.page)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.page.title.rendered), 1),
              _hoisted_5,
              _createElementVNode("div", {
                id: "my-konten",
                innerHTML: _ctx.page.content.rendered
              }, null, 8, _hoisted_6)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.p.title.rendered), 1),
              _hoisted_9,
              _createElementVNode("div", {
                id: "my-konten",
                innerHTML: _ctx.p.content.rendered
              }, null, 8, _hoisted_10)
            ]))
      ])
    ])
  ], 64))
}